<template>
    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-4">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">

                <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

                    <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
                         v-if="currentTask.testtask"
                         @click="play(mainElement.audio)">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{$t('№')}}{{currentTask.pos}}.</span>{{ currentTask.testtask }}
                    </div>

                    <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
                         v-if="test.description && test.description !== currentTask.testtask">{{
                        test.description }}
                    </div>

                    <div class="col-xl-12 col-12 mb-xl-2 mb-2 mt-2">

                        <div class="row">
                            <div class="offset-0 offset-xl-3 col-xl-6 col-12">
                                <img :src="mainElement.image"
                                     class="test-image single-image my-3"/>
                            </div>
                            <div class="offset-0 offset-xl-2 col-xl-8 col-12 mb-2 text-center">
                                <container
                                        :orientation="'horizontal'"
                                        group-name="col"
                                        :get-child-payload="index => {return answers[index]}"
                                        class="text-center"
                                        style="width: 100%; height: 80px;"
                                        @drop="onDrop">
                                        <!--@drag-start="(e) => log('drag start', e)"
                                        @drag-end="(e) => log('drag end', e)">-->
                                    <draggable
                                            class="mx-1 mx-xl-2"
                                            v-for="child in answers"
                                            :key="child.idtestelement">
                                        <div class="btn btn-secondary btn-lg test-question-btn px-2 px-xl-4">
                                            {{ child.word }}
                                        </div>
                                    </draggable>
                                </container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center text-center no-gutters">
                    <button
                            v-if="testmode==1"
                            class="btn btn-info mt-1"
                            @click="next"
                    >
                        {{ $t('accept_answer') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>

    </div>


</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<script>
    import api from '@/utils/api'
    import {Container, Draggable} from 'vue-smooth-dnd'

    export default {
        name: 'Test6',
        components: {
            Container,
            Draggable,
        },
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
            testmode: {default: 0},
        },
        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            answers: [],
            audio: new Audio(),

            upperDropPlaceholderOptions: {
                className: 'cards-drop-preview',
                animationDuration: '150',
                showOnTop: true,
            },
            dropPlaceholderOptions: {
                className: 'drop-preview',
                animationDuration: '150',
                showOnTop: true,
            },

            showTestIntro: true,
            //errorChord: 'gong.mp3',
            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
        }),

        computed: {
            currentTask: function () {
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            mainElement: function () {
                //console.log('mainElement', this.getBy('ismain', 1, this.testelements))
                return this.getBy('ismain', 1, this.testelements)
            },
        },

        watch: {
            taskIdx: function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            // workaround for "once smooth-dnd is touched, can not scroll any more page" https://github.com/kutlugsahin/smooth-dnd/issues/83#issuecomment-713486752
            const cleanClasses = () => {
              document.body.className = '';
            };
            document.addEventListener('touchend', cleanClasses, false);
        },

        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                if (this.currentTask.idtesttask) {
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data

                    this.answers = this.shuffle(this.getAnswers())
                } else {
                    this.$emit('testComplete')
                }
            },

            getAnswers() {
                return this.testelements.filter(function (e) {
                    return !e.ismain && !e.isright
                })
            },

            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            shuffle(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]]
                }
                return a
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            // console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },
            next() {
                if(this.complete) this.$emit('correctAnswer')
                else this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: `Неправильно составлено предложение.`})
                this.taskIdx++
            },
            async checkAnswer() {
                this.complete = true
                for (let i = 0; i < this.answers.length - 1; i++) {
                    if (this.answers[i].pos > this.answers[i + 1].pos) {
                        this.complete = false
                        return
                    }
                }

                if (this.testmode == 1) return

                if (this.mainElement.audio) {
                    await this.play(this.mainElement.audio)
                } else {
                    await this.play(this.okChord)
                }

                this.next()
            },

            onDrop(dropResult) {
                this.answers = this.applyDrag(this.answers, dropResult)
                this.checkAnswer()
            },

            dragStart() {
                //console.log('drag started')
            },
            log(...params) {
                console.log(...params)
            },

            applyDrag(arr, dragResult) {
                const {removedIndex, addedIndex, payload} = dragResult
                if (removedIndex === null && addedIndex === null) return arr

                const result = [...arr]
                let itemToAdd = payload

                if (removedIndex !== null) {
                    itemToAdd = result.splice(removedIndex, 1)[0]
                }

                if (addedIndex !== null) {
                    result.splice(addedIndex, 0, itemToAdd)
                }

                return result
            },

        },
    }
</script>

<style scoped>
    .smooth-dnd-draggable-wrapper {
        display: inline-block !important;
    }

    .form-ghost {
        transition: 0.18s ease;
        box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.08);
    }

    .form-ghost-drop {
        box-shadow: 0 0 2px 5px rgba(0, 0, 0, 0.0);
    }

    .drop-preview {
        background-color: rgba(150, 150, 200, 0.1);
        border: 1px dashed #abc;
        margin: 5px;
    }

    .cards-drop-preview {
        background-color: rgba(150, 150, 200, 0.1);
        border: 1px dashed #abc;
        margin: 5px 45px 5px 5px;
    }
</style>
